//imports
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { clientMutation } from 'Core/data/GraphQLApi';
import { ExceptionManager } from 'Core/logManager';
import { endpoints } from 'Core/defaultValues';

//Action types
import {
    KEYSFOBS_DELETE_REQUEST,
} from 'Redux/actionTypes';

//Actions
import {
    keyfobsDeleteResult,
} from 'Redux/actions';

function* deleteKeyFob({ payload }) {
    try {
        let QUERY = `
            mutation deleteKeyFob ($id: Int!, $hex: String!) {
                result: deleteKeyFob (id: $id, hex: $hex)
            }
        `;
        
        let data = yield call(
            clientMutation,
            QUERY,
            {
                id: payload.id,
                hex: payload.hex
            },
            endpoints.GRAPHQL_GENERAL,
        );

        yield put(keyfobsDeleteResult({ delete: data?.result }))

    } catch (exc) {
        yield put(keyfobsDeleteResult({ delete: false }))
        ExceptionManager(exc, 'Modules/keysFobs/.components/createEditKeyFob/redux/saga', 'deleteKeyFob');
    }
}

function* watchCatalogRequests() {
    yield takeEvery(KEYSFOBS_DELETE_REQUEST, deleteKeyFob);
}

//Saga Export
export default function* rootSaga() {
    yield all([
        fork(watchCatalogRequests)
    ]);
}